export default __webpack_public_path__ + "static/media/exterior5.d760c689.jpg";